(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptMetadataDialogController', RptMetadataDialogController);

    RptMetadataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptMetadata'];

    function RptMetadataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptMetadata) {
        var vm = this;

        vm.rptMetadata = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptMetadata.id !== null) {
                RptMetadata.update(vm.rptMetadata, onSaveSuccess, onSaveError);
            } else {
                RptMetadata.save(vm.rptMetadata, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptMetadataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
